// 头条小程序
import Url from '../utils/url';
export default {
  appName: 'douyin_show_microapp',
  useKNB: false,
  sellChannel: 31,
  theme: 'maoyan',
  hostPrefix: '//show.maoyan.com/qqw',
  hostBetaPrefix: '//show.test.maoyan.com/qqw',
  ajaxUrl: 'https://wx.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: 'http://m.51ping.com/myshow/ajax',
  linkMap: {
    // 地址跳转映射
    // 首页
    '/myshow/index.html': '/',
    '/movieshow/index.html': '/',
    // 列表相关
    '/movieshowlist/graphic-detail.html': '/graphic',
    '/movieshowlist/show-ticket.html': '/list',
    '/movieshowlist/show-merchant.html': '/merchants',
    '/movieshowlist/show-detail.html': '/detail',
    '/movieshowlist/group.html': '/group',
    '/movieshowlist/search.html': '/search',
    '/movieshowlist/show-shop.html': '/shop',
    // 下单相关
    '/movieshoworder/goods.html': '/tickets',
    '/movieshoworder/pre-order.html': '/confirm',
    '/movieshoworder/area.html': '/partition',
    '/movieshoworder/add-address.html': '/add-addr',
    '/movieshoworder/choose-address.html': '/choose-addr',
    '/movieshoworder/coupon-detail.html': '/coupon-detail',
    '/movieshoworder/seats.html': '/seats',
    '/movieshoworder/coupon.html': '/coupon',
    '/movieshoworder/order-detail.html': '/order-detail',
    '/movieshoworder/order-list.html': '/order-list',
    '/movieshoworder/real-names.html': '/realname',
    '/movieshoworder/seat-area.html': '/seat-area',
    '/movieshoworder/select-seats.html': '/select-seats',
    '/movieshoworder/search-order.html': '/search-order'
  },
  getUserInfo: function getUserInfo() {
    var token = Url.getQuery('_token') || Url.getHashQuery('_token');

    if (token) {
      localStorage.setItem('_token', token);
    } else {
      token = localStorage.getItem('_token');
    }

    var openId = Url.getQuery('_openId') || Url.getHashQuery('_openId');

    if (openId) {
      localStorage.setItem('_openId', token);
    } else {
      openId = localStorage.getItem('_openId');
    }

    var userId = Url.getQuery('_userId') || Url.getHashQuery('_userId');

    if (userId) {
      localStorage.setItem('_userId', userId);
    } else {
      userId = localStorage.getItem('_userId');
    }

    return {
      token: token,
      openId: openId,
      userId: userId
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Url.getQuery('_lat') || Url.getHashQuery('_lat'),
      lng: Url.getQuery('_lng') || Url.getHashQuery('_lng')
    };
  },
  getCity: function getCity() {
    return {
      cityId: Url.getQuery('_cityId') || Url.getHashQuery('_cityId')
    };
  },
  login: function login() {
    if (window.tt) {
      window.tt.miniProgram.navigateTo({
        url: "/pages/login/index"
      });
    }
  }
};